export enum CheckboxTheme {
  Green = 'green',
  Blue = 'blue',
}
